
export default {
  name: 'CheckIcon'
}
